import { GET_SUBSCRIPTION_LIST, GET_SUBSCRIPTION_LIST_SUCCESS, GET_SUBSCRIPTION_LIST_FAIL } from '../types';

const initState = {
  subscriptions: [],
  error: null,
  isLoading: false,
};

export default (state = initState, action) => {
  switch (action.type) {
    case GET_SUBSCRIPTION_LIST: {
      return { ...state, isLoading: true };
    }

    case GET_SUBSCRIPTION_LIST_SUCCESS: {
      const { payload } = action;

      return { ...state, isLoading: false, subscriptions: payload, error: null };
    }

    case GET_SUBSCRIPTION_LIST_FAIL: {
      const { payload } = action;

      return { ...state, isLoading: false, subscriptions: [], error: payload };
    }

    default:
      return state;
  }
};
